import { render } from "./MultipleImageInput.vue?vue&type=template&id=5742533b&scoped=true"
import script from "./MultipleImageInput.vue?vue&type=script&lang=js"
export * from "./MultipleImageInput.vue?vue&type=script&lang=js"

import "./MultipleImageInput.vue?vue&type=style&index=0&id=5742533b&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5742533b"]])

export default __exports__